export default __webpack_public_path__ + "static/media/logo.f87b466a.png";